import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { SocketProvider } from './contexts/SocketContext';
import { Web3Provider } from './contexts/Web3Context';

export const Providers = ({ children }) => {
  return (
    <AuthProvider>
      <Web3Provider>
        <SocketProvider>
          <SidebarProvider>{children}</SidebarProvider>
        </SocketProvider>
      </Web3Provider>
    </AuthProvider>
  );
};

export default Providers;